import { v4 as uuidv4 } from 'uuid'

/** H5 本地设备标识（清缓存前保持不变） */
export const H5_DEVICE_ID_KEY = 'h5_device_id'

/** 仅 H5：没有则生成并写入 storage，有则直接返回 */
export const ensureH5DeviceId = (): string => {
  let id = String(uni.getStorageSync(H5_DEVICE_ID_KEY) || '')
  if (!id) {
    id = `h5_${uuidv4().replace(/-/g, '')}`
    uni.setStorageSync(H5_DEVICE_ID_KEY, id)
  }
  return id
}

/** 读取已存的 H5 设备 id（不自动生成） */
export const getH5DeviceId = (): string => {
  return String(uni.getStorageSync(H5_DEVICE_ID_KEY) || '')
}
